var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26258_41402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48566 0 0 4.48609 0 10C0 15.5139 4.48566 20 10 20C15.5143 20 20 15.5139 20 10C20 4.48609 15.5143 0 10 0ZM13.9754 10.3504L8.14211 14.1004C8.07375 14.1447 7.9948 14.1667 7.91668 14.1667C7.84832 14.1667 7.77914 14.1496 7.7173 14.1158C7.58301 14.0426 7.5 13.9026 7.5 13.75V6.25C7.5 6.09742 7.58301 5.95742 7.7173 5.88418C7.84914 5.81176 8.01434 5.81621 8.14211 5.89965L13.9754 9.64965C14.0943 9.72613 14.1667 9.8584 14.1667 10C14.1667 10.1416 14.0943 10.2738 13.9754 10.3504Z",
    fill: "#106C3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26258_41402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.1eae50bf2d03acbf4a85f558204d3aa1.svg";
export { ForwardRef as ReactComponent };